import { lazyLoad } from 'utils/lazy';

export const Omnidesk = lazyLoad(
  () => import('./Omnidesk'),
  (module) => module.Omnidesk
);
